import {
    IListarFormularios,
    IVincularTemplateFormulario,
} from "../../../Interfaces/Geral/Formularios/FormulariosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function BaixarFormularioPDFService(
    idFormulario: number,
    idCaso: number,
    nrAgrupamento?: string
) {
    return Service(
        Axios.post<string>(
            `/vistoria/casovistoria/baixarchecklistpdf?idFormulario=${idFormulario}&idCaso=${idCaso}&nrAgrupamento=${
                nrAgrupamento ?? 0
            }`,
            {},
            { responseType: "blob" }
        )
    );
}

export async function ListarFormulariosTemplatesService(
    flVinculado: boolean,
    idModulo: number
) {
    return Service(
        Axios.get<Array<IListarFormularios>>(
            `/home/doctemplateform/listarformulariostemplates?flVinculado=${flVinculado}&idModulo=${idModulo}`
        )
    );
}

export async function VincularTemplateFormularioService(
    requestBody: IVincularTemplateFormulario
) {
    return Service(
        Axios.post(`/home/doctemplateform/vinculardoctemplateform`, requestBody)
    );
}

export async function DesvincularTemplateFormularioService(
    idDocumentoTemplateModulo: number,
    idFormulario: number
) {
    return Service(
        Axios.delete(
            `/home/doctemplateform/desvinculardoctemplateform?idDocTempModulo=${idDocumentoTemplateModulo}&idFormulario=${idFormulario}`
        )
    );
}
